import EmberObject from '@ember/object';

export function computeFromComponentValues(c1, r1, r3, r4, l1) {
  var gain = 1 + r4 / r3;
  var wp = Math.sqrt(1 / (c1 * l1));
  var fp = wp / (Math.PI * 2);
  var q = r1 * Math.sqrt(c1 / l1);

  var result = EmberObject.create({ stageQ: q, stageFp: fp, gain: gain });
  return result;
}

export function execute(circuit) {
  var r1 = circuit.r1.value;
  var r3 = circuit.r3 ? circuit.r3.value : null;
  var r4 = circuit.r4 ? circuit.r4.value : null;
  var c1 = circuit.c1.value;
  var l1 = circuit.l1.value;
  return this.computeFromComponentValues(c1, r1, r3, r4, l1);
}
